import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import {Link} from 'react-router-dom'
import MemberStatistic from 'app/modules/admin/member/MemberStatistic'
import {MemCountes} from '../../../redux/Slice/adminSlice'

const AdminDashboard = () => {
  const [loader, setLoader] = useState(true)
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const [memCounts, setMemCounts] = useState<any>(null)

  useEffect(() => {
    dispatch(MemCountes()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setMemCounts(res.payload)
        setLoader(false)
      }
    })
  }, [])

  if (loader) return <Loader />

  return (
    <div className='container-fluid px-4'>
      {/* Student Statistics Cards */}
      {memCounts && (
        <div className='row g-4 mb-5'>
          <div className='col-6'>
            <Link to='/admin/memberships' className='text-decoration-none'>
              <div className='card bg-primary text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-users mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('LABEL.MEMBERSHIPS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{memCounts.apps}</div>
                </div>
              </div>
            </Link>
          </div>

          <div className='col-6'>
            <Link to='/admin/arch-mems' className='text-decoration-none'>
              <div className='card bg-success text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-archive mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>
                      {t('LABEL.ARCHIVED', {name: t('LABEL.MEMBERSHIPS')})}
                    </span>
                  </div>
                  <div className='fs-1 fw-bold'>{memCounts.students}</div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      )}
      <MemberStatistic />
    </div>
  )
}

export default AdminDashboard
